import { Pipe, PipeTransform } from '@angular/core';
import { DeviceEnum, LanguageService } from '../../core';


/**
 * Pipe to convert Device enum to display value.
 */
@Pipe({
	name: 'deviceLabel'
})
export class DeviceLabelPipe implements PipeTransform {

	constructor(private readonly langSrv: LanguageService) { }

	transform(device?: DeviceEnum | null): string {
		if (!device) return '';
		return deviceTranslate(device, this.langSrv.labels());
	}

}


export const deviceTranslate = (device: DeviceEnum, labels: any): string => {
	switch (device) {
		case DeviceEnum.Tlhex: return labels.DEVICE_TLHEX_LABEL;
		case DeviceEnum.Fitbone: return labels.DEVICE_FITBONE_LABEL;
		case DeviceEnum.Jps: return labels.DEVICE_JPS_LABEL;
		case DeviceEnum.ToBeDefined: return '';
		default: return device;
	}
}
